<div cdkDrag cdkDragRootElement=".modal-dialog">
<div class="px-3 pt-3 pb-0 d-flex w-100 justify-content-between" cdkDragHandle>
  <div class="h4">{{title}}</div>
  <div>
    <button class="btn btn-secondary btn-sm small py-0 px-1" (click)="closeModal()">x</button>
  </div>
</div>
<div class="pt-0 modal-body text-center">
  <table *ngIf="!bJsonVisible" class="table table-sm table-striped table-compact" style="font-size:14px;">
    <tr *ngFor="let column of table.tableColumns">
      <th class="text-left text-nowrap py-0 px-2 m-0 mr-2 align-middle">{{column.title}}</th>
      <td class="w-100 text-left py-0 px-1 m-0 ">
        <ng-container *ngIf="bFormatted" [ngTemplateOutlet]="table.cellRendererTmplRef"
          [ngTemplateOutletContext]="{ record, column, tableComponent: table, showRequestFn: table.showRequestFn}">
        </ng-container>
        <ng-container *ngIf="!bFormatted" [ngSwitch]="record[column.name]">
          <span *ngSwitchCase="" style="color:rgb(220,220,220);" class="small font-italic">{{record[column.name]===undefined?'undefined':(record[column.name]===null?'null':record[column.name])}}</span>
          <pre *ngSwitchDefault class="m-0">{{record[column.name]|json}}</pre>
        </ng-container>
      </td>
    </tr>
  </table>
  <pre *ngIf="bJsonVisible" class="m-0 text-left">{{record|json}}</pre>
  <div class="d-flex flex-row justify-content-between align-items-center">
    <!-- do this later... table has everything needed to figure out next record
    <button class="btn btn-secondary" (click)="previousRecord()">
      << Previous
    </button>
    <button class="btn btn-secondary" (click)="nextRecord()">
      << Next
    </button>
    -->
    <div class="d-flex flex-row">
    <label *ngIf="table?.cellRendererTmplRef" title="Use table cell formatter (values may be rounded, truncated, etc...)">
      <input [disabled]="bJsonVisible" type="checkbox" [(ngModel)]="bFormatted"/>
      Formatted
    </label>
    <label class="ml-4" title="Raw JSON returned from server">
      <input type="checkbox" [(ngModel)]="bJsonVisible"/>
      JSON
    </label>
    </div>
    <button type="button" class="btn btn-primary" (click)="closeModal()">
      Close
    </button>
  </div>
</div>
</div>